// The ⌘ glyph only reads right on Mac; elsewhere spell the modifier out.
// Shortcuts fire on metaKey OR ctrlKey, so both labels are accurate. A leaf
// module on purpose: hotkey hooks, the shortcuts catalog and the search chrome
// all read it, and a constant living in a component module puts every one of
// them in an import cycle with that component's own imports.
export const IS_MAC =
  typeof navigator !== "undefined" &&
  /Mac|iPhone|iPad/.test(navigator.userAgent);

/**
 * Keycaps as one run of text for a `MenuShortcut` slot: the Mac glyphs sit
 * together ("⌥⇧Q", "⌘/"); spelled-out keys read with spaces ("Alt Shift Q",
 * "Ctrl /").
 */
export function shortcutLabel(keys: readonly string[]): string {
  return keys.join(IS_MAC ? "" : " ");
}

// iPadOS reports a Mac user agent; touch points tell it apart.
function isIOS(nav: Pick<Navigator, "userAgent" | "maxTouchPoints">): boolean {
  return /iPhone|iPad|iPod/.test(nav.userAgent) || (/Mac/.test(nav.userAgent) && nav.maxTouchPoints > 1);
}

/**
 * iOS Safari zooms into a focused field set under 16px. It honours
 * `maximum-scale=1` for that focus zoom but ignores it for pinch, so on iOS the
 * cap stops the zoom without taking user zoom away (other platforms never get it).
 */
export function capIOSFocusZoom(doc: Document = document, nav: Navigator = navigator): void {
  if (!isIOS(nav)) return;
  const meta = doc.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta || meta.content.includes("maximum-scale")) return;
  meta.content = `${meta.content}, maximum-scale=1`;
}
